// import 'core-js/stable';
// import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";

import jquery from "jquery";
import "./modules/env/long-press-event.min.js";
import "./modules/env/jquery.drum.min.js";
import "./modules/env/slick.min.1.6.0.js";
import "./modules/env/circle-progress.js";

import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
